import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "image-align-right-icon",
  role: "img",
  "aria-label": "Image align right icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.75 3.5c0 .41-.34.75-.75.75H3a.75.75 0 0 1 0-1.5h18c.41 0 .75.34.75.75Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.75 8c0-.97.78-1.75 1.75-1.75H17c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-2.5c-.97 0-1.75-.78-1.75-1.75V8Zm1.75-.25a.25.25 0 0 0-.25.25v8c0 .14.11.25.25.25H17c.14 0 .25-.11.25-.25V8a.25.25 0 0 0-.25-.25h-2.5Z"
    }, null, -1),
    _createElementVNode("path", { d: "M21 21.25a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5h18Z" }, null, -1)
  ])))
}
export default { render: render }